
import { FormData } from '@/types/form';

export const useUtilityValidation = (formData: FormData, uploadedFiles: { gas: string | null; electricity: string | null; water: string | null; }) => {
  const validateUtilityInputs = (type: 'gas' | 'electricity' | 'water') => {
    if (uploadedFiles[type]) {
      console.log(`${type} file uploaded, validation passed`);
      return true;
    }

    let isValid = false;

    if (type === 'water') {
      const waterFields = [
        formData.waterStartDate,
        formData.waterEndDate,
        formData.waterTotalCharge,
        formData.waterVolumeCharge
      ];

      isValid = waterFields.every(value => {
        const trimmedValue = typeof value === 'string' ? value.trim() : value;
        return trimmedValue !== undefined && trimmedValue !== null && trimmedValue !== '';
      });

      console.log('Water fields state:', waterFields);
      console.log(`Water validation result: ${isValid}`);

    } else {
      const fields = [
        formData[`${type}Usage`],
        formData[`${type}Rate`],
        formData[`${type}StartDate`],
        formData[`${type}EndDate`]
      ];

      isValid = fields.every(value => {
        const trimmedValue = typeof value === 'string' ? value.trim() : value;
        return trimmedValue !== undefined && trimmedValue !== null && trimmedValue !== '';
      });

      console.log(`${type} fields state:`, fields);
      console.log(`${type} validation final result:`, isValid);
    }

    return isValid;
  };

  const validatePropertyDetails = () => {
    const propertyFields = ['street', 'number', 'postcode', 'squareFootage', 'occupants', 'age'];
    const propertyValues = propertyFields.map(field => ({
      field,
      value: formData[field as keyof FormData]
    }));
    
    console.log('Property fields state:', propertyValues);
    
    const isValid = propertyFields.every(field => {
      const value = formData[field as keyof FormData];
      const isValidValue = value !== undefined && value !== null && value !== '';
      console.log(`Checking property field ${field}: ${value}, isValid: ${isValidValue}`);
      return isValidValue;
    });
    
    console.log('Property details validation result:', isValid);
    return isValid;
  };

  return {
    validateUtilityInputs,
    validatePropertyDetails
  };
};
